<input
  [type]="field.type"
  [placeholder]="field.placeholder"
  [formControl]="control"
/>
